import { RegisteredRouter, SearchPaths, ToSubOptions, useRouter } from '@tanstack/react-router';
import { LocalizedText } from '@mews/framework';
import { RoutePaths } from '../navigation/enterprise/types';
import { LinkTab } from './Tabs/LinkTab';

/**
 * replace with `CheckFromPath` from tanstack router when we upgrade to the version that exports it
 * -> from: CheckFromPath<RegisteredRouter, From, 'Invalid route path', From>
 */
type CheckFromPath<From extends string> = ToSubOptions<RegisteredRouter, From>['from'] & {};

/**
 * TypeScript was running into issues with `Expression produces a union type that is too complex to represent.`
 * As a workaround, we relaxed the generic type with `string & {}` which preserves autocomplete.
 * Then we check if the path is a valid route path with `CheckFromPath`.
 */
export const useTabs = <From extends RoutePaths | (string & {})>(
    from: CheckFromPath<From>,
    tos: SearchPaths<RegisteredRouter, From>[]
) => {
    const router = useRouter();

    return tos.map((to) => {
        /**
         * The input types are strongly typed for this to work correctly, so the ignore is a good enough
         * until we figure out proper solution.
         */
        const m = router.routesByPath[`${from}/${to}` as RoutePaths];
        return (
            <LinkTab to={m.to} key={m.to}>
                {m.options?.staticData?.title ? <LocalizedText textKey={m.options.staticData.title} /> : null}
            </LinkTab>
        );
    });
};
